import { render } from "./BankTransfersCard.vue?vue&type=template&id=185c8388&scoped=true"
import script from "./BankTransfersCard.vue?vue&type=script&lang=js"
export * from "./BankTransfersCard.vue?vue&type=script&lang=js"

import "./BankTransfersCard.vue?vue&type=style&index=0&id=185c8388&scoped=true&lang=css"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-185c8388"],['__file',"src/components/BankTransfersCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "185c8388"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('185c8388', __exports__)) {
    console.log('reload')
    api.reload('185c8388', __exports__)
  }
  
  module.hot.accept("./BankTransfersCard.vue?vue&type=template&id=185c8388&scoped=true", () => {
    console.log('re-render')
    api.rerender('185c8388', render)
  })

}


export default __exports__